import { RequestService } from '../../../../../common/services/RequestService';
import { ADVERTISINGS_GET } from '../../constants';

export const getAdvertisingsRequest = payload => {
  return RequestService.get(ADVERTISINGS_GET);
};
